import { isEmpty } from 'lodash';
import { useEffect } from 'react';
import { Snackbar } from 'src/components/snackbar';
import { useModal } from 'src/hooks';
import { lang } from 'src/utils';

import { FormWrapperProps } from './FormWrapper.interface';

export const FormWrapper = (props: FormWrapperProps) => {
  const saveComponentModal = useModal();

  useEffect(() => {
    if (props.formState.isSubmitSuccessful) {
      saveComponentModal.onCloseModal();
    }
    if (!props.formState.isValid && !isEmpty(props.formState.errors)) {
      saveComponentModal.onCloseModal();
      Snackbar.error(lang.failedToSave);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    props.formState.isValid,
    props.formState.errors,
    props.formState.isSubmitSuccessful,
  ]);

  return (
    <>
      <form>
        <div>{props.children}</div>
      </form>
    </>
  );
};
